import { useState } from "react";

import { isWorldwideCountry } from "app/pages/sales-intelligence/sub-modules/account-overview/shared/helpers/countries";
import { CountryRadioSelectorEnum } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/base";
import useCountriesWithoutWW from "app/pages/sales-intelligence/sub-modules/signals/hooks/useCountriesWithoutWW";
import type { ICountryObject } from "app/services/CountryService";
import CountryService from "app/services/CountryService";

type HookParams = {
    countries: ReadonlyArray<Readonly<ICountryObject>>;
    newMarketCountries?: readonly number[];
};

type HookReturnValue = {
    selectedRadio: string;
    setSelectedRadio: (data: string) => void;
    countriesWithoutWW: ReadonlyArray<Readonly<ICountryObject>>;
    hasWWInCountries: boolean;
    isOnlyWW: boolean;
    preServingCountries: number[];
    setPreServingCountries: (data: number[]) => void;
};
const useCountryFilterData = ({ countries, newMarketCountries }: HookParams): HookReturnValue => {
    const isWWSelectedRadio =
        newMarketCountries &&
        newMarketCountries.length === 1 &&
        CountryService.isWorldwideCountry(newMarketCountries[0]);

    const hasWWInCountries = typeof countries.find(isWorldwideCountry) !== "undefined";

    const countriesWithoutWW = useCountriesWithoutWW(countries);

    const isOnlyWW = countriesWithoutWW.length === 0 && hasWWInCountries;

    const [preServingCountries, setPreServingCountries] = useState<number[]>([]);

    const [selectedRadio, setSelectedRadio] = useState(
        (isWWSelectedRadio || isOnlyWW
            ? CountryRadioSelectorEnum.Worldwide
            : CountryRadioSelectorEnum.Specific) as string,
    );

    return {
        selectedRadio,
        setSelectedRadio,
        countriesWithoutWW,
        hasWWInCountries,
        isOnlyWW,
        preServingCountries,
        setPreServingCountries,
    };
};

export default useCountryFilterData;
